export const plexZonePositionTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined && categoryid !== undefined) {
		if (categoryid.indexOf('plex_service.py') !== -1) {
			if (desyncdata.indexOf('TypeError: an integer is required (got type NoneType)') !== -1 || desyncdata.indexOf('TypeError: must be Vector3, not None') !== -1) {
				return {
					type: 'plexZonePositionTest',
					color: 'MediumAquamarine',
					title: 'Plex Zone Position Error',
					text: 'Base game issue with apartments.',
					description: 'For the most part, you\'re safe to ignore this error.'
				}
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>e634528a38ba630b5b560ba8</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-07-23 19:18:08</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.88.1020-1.200.000.354.Release</buildsignature>
        <categoryid>plex_service.py:144</categoryid>
        <desyncid>e634528a38ba630b5b560ba8</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception in Sim Timeline: Exception running Element (TypeError: an integer is required (got type NoneType))
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\alarms.py&quot;, line 293, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\apartments\apartment_zone_director.py&quot;, line 73, in &lt;lambda&gt;
  File &quot;T:\InGame\Gameplay\Scripts\Server\apartments\apartment_zone_director.py&quot;, line 135, in _run_common_area_cleanup
  File &quot;T:\InGame\Gameplay\Scripts\Server\situations\service_npcs\modify_lot_items_tuning.py&quot;, line 197, in modify_objects
  File &quot;T:\InGame\Gameplay\Scripts\Server\apartments\apartment_zone_director.py&quot;, line 134, in object_criteria
  File &quot;T:\InGame\Gameplay\Scripts\Server\plex\plex_service.py&quot;, line 144, in get_plex_zone_at_position
TypeError: an integer is required (got type NoneType)
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/basegame/plexZoneTest.js